var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "evenodd",
    d: "M13.18 3.328 12.833 3l-.349.328-8.651 8.142.698.741 8.302-7.813 3.053 2.873 2.693 2.534 2.557 2.406.697-.741-1.875-1.765V3.699h-4.072v2.175zm5.759 5.42L16.903 6.83V4.717h2.036zm-9.16 11.234H6.725v-5.088H5.707V21h14.25v-6.106h-1.018v5.088h-3.054v-7.124H9.78zm1.018 0v-6.106h4.07v6.106z",
    clipRule: "evenodd"
  })));
};
export default SvgHouse;